import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

export const issueSalesOrderRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/sales-orders/:id/issue',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/sales-orders/:id/issue' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

export const issueSalesOrdersResponse: Json = {
    title: 'RESPONSE',
    json: {
        "id": 7,
        "number": "10010",
        "carrier": {
            "id": 4,
            "name": "Fedex",
            "service": {
                "id": 8,
                "name": "Ground"
            }
        },
        "fobPointName": "Origin",
        "paymentTerms": {
            "id": 5,
            "name": "2% 10 NET 40"
        },
        "customer": {
            "id": 43,
            "name": "Big Al's Bike Shop"
        },
        "vendorPoNumber": "",
        "customerPoNumber": "",
        "customerContact": "Big Al's Bike Shop",
        "salesperson": {
            "id": 1,
            "name": "admin"
        },
        "deliverTo": "Big Al's Bike Shop",
        "revisionNumber": 3,
        "lastModified": {
            "username": "admin",
            "dateLastModified": "2025-04-11T11:26:11.717-06"
        },
        "dateCreated": "2025-03-06T08:54:22.000-07",
        "dateRevision": "2025-03-06T19:51:41.363-07",
        "dateScheduled": "2025-03-06T08:54:22.000-07",
        "totalTax": "0",
        "totalPrice": "50",
        "mcTotalTax": "0",
        "mcTotalPrice": "50",
        "totalIncludesTax": false,
        "locationGroup": {
            "id": 5,
            "name": "SLC"
        },
        "note": "",
        "url": "",
        "email": "",
        "phone": "801-932-1101",
        "shipToAddress": {
            "name": "Big Al's Bike Shop",
            "street": "Big Al's Bike Shop",
            "city": "Seattle",
            "state": "WA",
            "postalCode": "98199",
            "country": "UNITED STATES"
        },
        "billToAddress": {
            "name": "Big Al's Bike Shop",
            "street": "Big Al's Bike Shop",
            "city": "Seattle",
            "state": "WA",
            "postalCode": "98199",
            "country": "UNITED STATES"
        },
        "status": "Issued",
        "class": {
            "id": 1,
            "name": "None"
        },
        "shipTerms": "Prepaid & Billed",
        "type": "Standard",
        "soItems": [
            {
                "id": 11,
                "product": {
                    "id": 81,
                    "name": "B203",
                    "description": "Basic Brake Cables"
                },
                "type": {
                    "id": 10,
                    "name": "Sale"
                },
                "uom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "lineNumber": 1,
                "customerPartNumber": "",
                "unitPrice": "10",
                "totalTax": "0",
                "totalPrice": "30",
                "mcTotalTax": "0",
                "mcTotalPrice": "0",
                "taxRate": {
                    "id": 1,
                    "name": "None",
                    "rate": 0.0
                },
                "dateScheduled": "2025-03-06T19:51:41.377-07",
                "revision": "",
                "note": "",
                "status": "Entered",
                "quantity": "5",
                "quantityFulfilled": "0",
                "quantityPicked": "0",
                "class": {
                    "id": 1,
                    "name": "None"
                },
                "customFields": []
            }
        ],
        "customFields": [
            {
                "id": 20,
                "name": "Custom",
                "type": "Text"
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'issue-sales-order',
    title: 'Issue a sales order',
    description: 'Issues the sales order with the specified ID.',
    endpoint: {
        verb: 'POST',
        path: '/sales-orders/:id/issue',
        tooltip: 'Issue a sales order',
    },
    attributes: [],
    requestObject: issueSalesOrderRequest,
    responseObject: issueSalesOrdersResponse,
};

export default data;
